import React from 'react';
import type { DrillBlastRequestHistoryItem } from 'shared/api/workspace/drill-blast/types';
import { DrillAndBlastHistoryAccordionItem } from './drill-and-blast-history-accordion-item';

type DrillAndBlastHistoryListProps = {
  items: DrillBlastRequestHistoryItem[];
};

export const DrillAndBlastHistoryList: React.FC<
  DrillAndBlastHistoryListProps
> = ({ items }) => {
  return (
    <div className="drill-and-blast__container__history-list">
        {items.map((item) => (
          <DrillAndBlastHistoryAccordionItem item={item} key={item.id} />
        ))}
    </div>
  );
};
